import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";
// import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import Breadcrumb from "../../Component/Breadcrumb";
import ServiceFAQSBox from "../../Component/ServiceCMPT/ServiceFAQSBox";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function ServiceDetails() {
  const { serviceslug } = useParams();
  const navigate = useNavigate();
  const { RendomTokenfetch } = useAuth();
  const [ServiceDetails, setServiceDetails] = useState([]);
  const [MultiFaqsdata, setMultiFaqsdata] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [ShowServiceData, setShowServiceData] = useState(true);
  // console.log(MultiFaqsdata);

  const FetchServiceData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(
          `${WebsiteAPIurl}serviceDetailsAPI.php?serviceslug=${serviceslug}`,
          {
            headers: {
              Authorization: RendomTokenfetch,
            },
          }
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setServiceDetails(response.data.servicedata);
            setMultiFaqsdata(response.data.multiFaqsdata);
            // setShowServiceData(true);
          } else {
            setServiceDetails([]);
            setMultiFaqsdata([]);
            // setShowServiceData(false);
          }
        });
    } catch (error) {
      console.error("API Error:", error);
      navigate("/page-not-found", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, serviceslug, navigate]);

  useEffect(() => {
    FetchServiceData();
  }, [FetchServiceData, serviceslug]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <title>{ServiceDetails.meta_title}</title>
        <meta name="description" content={ServiceDetails.meta_description} />
        <meta name="keywords" content={ServiceDetails.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb
        pagename={ServiceDetails?.title || ""}
        mainpage={"services"}
      />

      <section className="service-details-section section-padding">
        <div className="container">
          <div className="service-details-wrapper">
            <div className="row g-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-10">
                <div className="gt-details-thumb">
                  <img
                    src={ServiceDetails.image}
                    alt={ServiceDetails.image_alt}
                    title={ServiceDetails.image_title}
                  />
                </div>
                <div className="gt-details-content">
                  <h2>{ServiceDetails?.title || ""}</h2>
                  <p className="mt-3">{ServiceDetails?.tagline || ""}</p>
                  <span className="gt-box">
                    {ServiceDetails?.sub_title || ""}
                  </span>

                  <div
                    className="gt-list-content mb-0"
                    dangerouslySetInnerHTML={{
                      __html: ServiceDetails.description,
                    }}
                  ></div>

                  <div className="row">
                    {ServiceDetails.image1 !== "" && (
                      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <div className="details-img">
                          <img src={ServiceDetails.image1} alt="" />
                        </div>
                      </div>
                    )}
                    {ServiceDetails.image2 !== "" && (
                      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <div className="details-img">
                          <img src={ServiceDetails.image2} alt="" />
                        </div>
                      </div>
                    )}
                    {ServiceDetails.image3 !== "" && (
                      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <div className="details-img">
                          <img src={ServiceDetails.image3} alt="" />
                        </div>
                      </div>
                    )}
                  </div>

                  {MultiFaqsdata.length > 0 && (
                    <div className="faq-content">
                      <h3> {ServiceDetails?.faq_title || ""}</h3>
                      <div className="faq-accordion">
                        <div className="accordion" id="accordion">
                          {MultiFaqsdata.map((valu, index) => (
                            <ServiceFAQSBox key={index} faqsData={valu} />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-1"></div>
              {/* Sidebar Col-lg-4 Start*/}
              {/* <ServiceDetailsSitebar services={services} /> */}
              {/* Sidebar Col-lg-4 End*/}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
